export default __webpack_public_path__ + "static/media/cone.3cb42695.svg";